
import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {ReplaySubject, Subject} from 'rxjs';
import {delay, take, takeUntil} from 'rxjs/operators';
import {MatSelect} from '@angular/material/select';


interface Branch {
  id: string;
  branchName: string;
  branchCode: string;
}

@Component({
  selector: 'app-multi-branch',
  templateUrl: './multi-autocomplete-branch.component.html',
  styleUrls: ['./multi-autocomplete-branch.component.scss']
})

export class MultiBranch implements OnInit, AfterViewInit, OnDestroy {

  public branchFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public filteredBranch: ReplaySubject<Branch[]> = new ReplaySubject<Branch[]>(1);

  @ViewChild('multiSelect') multiSelect: MatSelect;
  protected _onDestroy = new Subject<void>();


  @Input() set data(data: any[]) {
    this._data = data;
    this.filteredBranch.next(this.data.slice());
  }

  get data(): any[] {
    return this._data;
  }


  private _data: any[];

  @Output() result: EventEmitter<any> = new EventEmitter<any>();
  @Input() outlineLabel: string;
  @Input() itemMultiCtrl: UntypedFormControl;

  account: any = {};



  ngOnInit() {
    this.branchFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy), delay(1000))
      .subscribe(() => {
        this.filterBranches();
      });
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onChange($event) {
    this.result.emit($event);
  }


  protected setInitialValue() {
    this.filteredBranch
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.multiSelect.compareWith = (a: Branch, b: Branch) => a && b && a.id === b.id;
      });
  }


  protected filterBranches() {
    if (!this.data) {
      return;
    }

    let search = this.branchFilterCtrl.value;
    if (!search) {
      this.filteredBranch.next(this.data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredBranch.next(
      this.data.filter(branch => branch.branchName.toLowerCase().indexOf(search) > -1)
    );
  }
}
